import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';

export function ReferralPage() {
  const { t } = useTranslation(['common']);
  const { user } = useAuth();
  const link = user
    ? `${window.location.origin}/?ref=${encodeURIComponent(user.public_id)}`
    : null;

  return (
    <div className="page">
      <h1>{t('common:referralTitle', { defaultValue: 'Referral' })}</h1>
      <div className="state-card">
        {link ? (
          <>
            <p>{t('common:referralLinkHint', { defaultValue: 'Your referral link (rewards inactive until admin configures them):' })}</p>
            <button
              type="button"
              className="btn btn-ghost"
              onClick={() => void navigator.clipboard.writeText(link)}
            >
              {link}
            </button>
          </>
        ) : (
          <p>{t('common:loginRequiredShort', { defaultValue: 'Sign in to view your referral link.' })}</p>
        )}
        <p className="muted-note">
          {t('common:referralUnavailable', {
            defaultValue: 'Referral rewards are not awarded until an admin enables a campaign. Self-referral is blocked.',
          })}
        </p>
      </div>
    </div>
  );
}
